<template>
  <div>
    <h3 class="mb-4">组织名称：{{ currentData.organizationName }}</h3>
    <Row>
      <Col span="11">
        <Card class="cardDiv">
          <p slot="title">选择机构</p>
          <Tree
            ref="tree"
            :data="treeData"
            @on-check-change="checkData"
            show-checkbox
          ></Tree>
        </Card>
      </Col>
      <Col span="11" offset="2">
        <Card class="cardDiv">
          <p slot="title">目标机构</p>
          <Tree :data="treeData_select"></Tree>
        </Card>
      </Col>
    </Row>
    <div class="text-center mt-5">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit()">确 定</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  data: function () {
    return {
      organizationData: {},
      treeData: [],
      treeData_select: [],
    };
  },

  created: function () {
    this.getListTree();
    this.getListTreeById();
  },

  methods: {
    //获取机构树
    getListTree() {
     
      var parm = { ids: [] };
      this.$api.post("/organ/getListTree", parm).then((rsp) => {
        if (rsp != false) {
          this.treeData = rsp.data;
        }
      });
    },
    returnBack: function () {
      this.$emit("close");
    },
    checkData: function (arr, currentdDta) {},

    handleSubmit() {
      let selectData = this.$refs["tree"].getCheckedAndIndeterminateNodes();
      let arr = [];
      for (let item of selectData) {
        let obj = {
          OrganID: item.organID,
          OrganName: item.organName,
          OrganCode: item.organCode,
          OrganParentID: item.organParentID,
        };
        arr.push(obj);
      }
      let data = {
        Id: this.currentData.id,
        UpdateUser: this.$store.state.name,
        organizationModels: arr,
      };

      this.$api.post("organization/allocationOrgan", data).then((rsp) => {
        if (rsp != false) {
          this.$Message.success("分配成功");
          this.returnBack();
        }
      });
    },

    //获取该组织下的机构树
    getListTreeById() {
      let id = this.currentData.id;
      this.$api.get(`/organization/getListTreeById?id=${id}`).then((rsp) => {
        if (rsp != false) {
          this.treeData_select = rsp.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.cardDiv {
  height: 400px;
  overflow: auto;
}
</style>